interface IConfiguracaoIconProps {
  color: string;
}

export const ConfiguracaoIcon: React.FC<IConfiguracaoIconProps> = ({ color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 16.25C9.92893 16.25 8.25 14.5711 8.25 12.5C8.25 10.4289 9.92893 8.75 12 8.75C14.0711 8.75 15.75 10.4289 15.75 12.5C15.75 14.5711 14.0711 16.25 12 16.25ZM12 14.75C13.2426 14.75 14.25 13.7426 14.25 12.5C14.25 11.2574 13.2426 10.25 12 10.25C10.7574 10.25 9.75 11.2574 9.75 12.5C9.75 13.7426 10.7574 14.75 12 14.75Z"
        fill={color}
      />
      <path
        d="M20.2352 15.3549L19.8285 16.3261L20.5937 19.1059L18.5826 21.117L15.8025 20.3426L14.832 20.7428L13.4045 23.249H10.5612L9.14206 20.735L8.17266 20.3286L5.39201 21.0937L3.38198 19.0836L4.15644 16.3035L3.75612 15.3329L1.25 13.9044V11.0611L3.76502 9.64199L4.17144 8.67266L3.40633 5.89201L5.41549 3.88286L8.19559 4.6584L9.16557 4.25836L10.5909 1.75H13.4348L14.854 4.26502L15.8233 4.67144L18.6036 3.90643L20.6161 5.91602L19.8415 8.69646L20.2416 9.66658L22.75 11.0919V13.9358L20.2352 15.3549ZM18.1413 19.437L18.9158 18.6625L18.2448 16.2247L19.0502 14.3012L21.25 13.0599V11.9648L19.0518 10.7157L18.258 8.79117L18.9359 6.358L18.1608 5.58402L15.7214 6.25523L13.8001 5.44966L12.5589 3.25H11.4638L10.2147 5.44824L8.29002 6.24201L5.85651 5.56316L5.08412 6.33554L5.75523 8.77457L4.94966 10.6959L2.75 11.9371V13.0328L4.94643 14.2848L5.73994 16.2088L5.06202 18.6424L5.83554 19.4159L8.27457 18.7448L10.1958 19.5503L11.437 21.749H12.5327L13.7837 19.5526L15.7078 18.7591L18.1413 19.437Z"
        fill={color}
      />
    </svg>
  );
};
